import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';

import type { AssetsStatusesEntry } from '@features/asset-management/asset-management.types';
import { AssetStatus } from '@features/asset-management/asset-management.types';
import type { NewInvestigationFormValues } from '@features/investigations/components/modals/add-new-investigation/investigation.schema';
import type { GenericMultiSelectOption } from '@shared/components/ui/custom';

import type { CreateFilePayload } from '../../../api/files.types';

dayjs.extend(utc);

type InvestigationTargetKeys = 'userName' | 'systemName' | 'ipAddress';

const TARGET_TYPE_MAP: Record<string, InvestigationTargetKeys> = {
  user: 'userName',
  host: 'systemName',
  ip: 'ipAddress',
};

// TODO(file-launch-renaming): rename util function/type names to neutral file-launch terminology.
export function mapFormValuesToPayload(data: NewInvestigationFormValues) {
  const dateFrom = data.dateRange?.from?.toISOString() ?? '';
  const dateTo = data.dateRange?.to?.toISOString() ?? '';

  const payload: CreateFilePayload = {
    traceName: data.traceName,
    dateFrom,
    dateTo,
    assets: data.assets,
    reservationId: data.reservationId,
    type: data.type,
  };

  if (data.type === 'INQUIRY') {
    payload.userName = data.inquiryUsername ?? '';
    return payload;
  }

  if (data.type === 'INVESTIGATION') {
    payload.sendEmailNotification = true;

    data.targets.forEach((target) => {
      const backendKey = TARGET_TYPE_MAP[target.type];
      if (backendKey) {
        payload[backendKey] = target.value;
      }
    });
  }

  return payload;
}

export function getAssetOptions(assets: AssetsStatusesEntry[]): GenericMultiSelectOption[] {
  return [...assets]
    .sort((a, b) => {
      const diff = Number(a.status !== AssetStatus.READY) - Number(b.status !== AssetStatus.READY);
      return diff || a.name.localeCompare(b.name);
    })
    .map((asset) => ({
      value: asset.name,
      label: asset.name,
      disabled: asset.status !== AssetStatus.READY,
    }));
}
